import React from 'react';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from '@app/layouts/layout';

import {
  QmManageMonitoringForms,
  QmManageMonitoringFormsCreatePage,
} from '@app/pages/qm-module/qm-manage-monitoring-forms';
import CriteriaTab from '@app/pages/qm-module/qm-manage-monitoring-forms/blocks/criteria/criteria-tab';
import MonitoringFormsSettingsOutlet from '@app/pages/qm-module/qm-manage-monitoring-forms/monitoring-forms-settings.outlet';
import QmManageMonitoringFormsSettingPage from '@app/pages/qm-module/qm-manage-monitoring-forms/qm-manage-monitoring-forms-settings.page';

import RequiredAuth from '../required-auth.route';

export const qmMonitoringFormsRoute = (
  // <Route
  //   path={navigationRoutes.qm_module_manage}
  //   handle={{
  //     crumb: () => <BreadcrumbsItem path={navigationRoutes.qm_module_manage} crumb="qm_manage" />,
  //   }}
  //   element={
  //     <RequiredAuth>
  //       <QmManageOutlet />
  //     </RequiredAuth>
  //   }
  // >
  <Route
    path={navigationRoutes.qm_manage_monitoring_forms}
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.qm_manage_monitoring_forms} crumb="qm_manage" />
      ),
    }}
  >
    <Route
      index
      element={
        <RequiredAuth>
          <QmManageMonitoringForms />
        </RequiredAuth>
      }
    />

    <Route
      path=":id"
      element={
        <RequiredAuth>
          <MonitoringFormsSettingsOutlet />
        </RequiredAuth>
      }
    >
      <Route index element={<QmManageMonitoringFormsSettingPage />} />
      <Route
        path={navigationRoutes.qm_manage_monitoring_forms_criteria_tab}
        element={<CriteriaTab />}
      />
    </Route>

    <Route
      path={navigationRoutes.newProject}
      element={
        <RequiredAuth>
          <QmManageMonitoringFormsCreatePage />
        </RequiredAuth>
      }
    />
  </Route>
  // </Route>
);
